module.exports = __webpack_public_path__ + "img/myazu_0.c70adeb1.jpg";